<template>
  <section :class="{
    'style-round': cornerStyle === 'round',
    'style-square': cornerStyle === 'square',
    fontLoaded
  }">
    <button :style="{ fontFamily: fontFamilyCSS }"
            id="btn-reset"
            v-on:click="submit($event)"
    >
      Submit Another
    </button>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'ResetButton',
  computed: {
    ...mapState('poll', ['cornerStyle', 'fontLoaded']),
    ...mapGetters('poll', ['fontFamilyCSS'])
  },
  methods: {
    ...mapActions('poll', [
      'resetVoting'
    ]),
    async submit(event) {
      event.preventDefault();
      this.resetVoting();
    }
  }
}
</script>

<style scoped lang="scss">
section {
  flex: 0 0 auto;
  width: 100%;
  margin: 0 !important;
  position: relative;
  z-index: 1;
}

button {
  font-size: var(--answer-fontsize);
  line-height: 1em;
  padding: 16px 20px 14px;
  text-align: center;
  border: none;
  border-radius: var(--button-radius);
  display: block;
  width: 100%;
  background-color: #b0b1b1e0;
  color: var(--button-color);
  cursor: pointer;
  opacity: 0;
  margin-bottom: var(--answer-bottommargin);
  text-shadow: 1px 1px #0000003d;
  outline: none;

  &:disabled {
    cursor: not-allowed;
  }
}

.style-square {
  button {
    border-radius: 4px;
  }
}

.fontLoaded {
  button {
    opacity: 1;
    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>
